export function ContactSection(): JSX.Element {
  return (
    <section
      id="contact"
      data-testid="landing-contact"
      className="py-[var(--landing-section-py)] bg-[var(--landing-bg)]"
    >
      <div className="max-w-[var(--landing-container-max)] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[var(--landing-text-primary)] mb-4">
          Get in touch
        </h2>
        <p className="text-lg text-[var(--landing-text-muted)] max-w-xl mx-auto mb-8">
          Have a question or need help getting started? We&apos;d love to hear from you.
        </p>
        <a
          href="mailto:support@resida.me"
          data-testid="contact-email-link"
          className="inline-flex items-center justify-center min-h-[44px] px-8 py-3 rounded-[var(--landing-radius)] border border-[var(--landing-accent)] text-[var(--landing-accent-text)] hover:bg-[var(--landing-accent)] hover:text-white text-base font-semibold transition-colors"
        >
          support@resida.me
        </a>
      </div>
    </section>
  );
}
